import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import Loader from "../../../components/Loader";
// import Loader from "../../components/LorTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const AptevoInventorySourcePage = () => {
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const fileName = 'Aptevo Inventory Source';
    const [inventory, setInventory] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);

    // excel Headers
    const excelColumns = [

        {
            Header: "PRODUCT",
            accessor: "ProductName",
            filter: "ProductName",
            sortType: "basic",
            width:200,
        },
        {
            Header: "NDC",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
            width:130,
        },
        {
            Header: "LOT",
            accessor: "LotNumber",
            filter: "LotNumber",
            sortType: "basic",
            width:90,
        },
       
        {
            Header: "LOT Exp",
            accessor: "ExpirationDate",
            filter: "ExpirationDate",
            sortType: "basic",
            width:110,
        },
        {
            Header: "#Vials purchased",
            accessor: "QP",
            filter: "QP",
            sortType: "basic",
            width:140,
        },
        {
            Header: "Remaining vials",
            accessor: "AvailableQuantity",
            filter: "AvailableQuantity",
            sortType: "basic",
            width:135,
        },
        {
            Header: "TOTAL UNITS",
            accessor: "TotalUnit",
            filter: "TotalUnit",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Units/Vial",
            accessor: "UnitsOrVial",
            filter: "UnitsOrVial",
            sortType: "basic",
            width:105,
        },
        {
            Header: "LOCATION",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "Purchase Date",
            accessor: "ReportingDate",
            filter: "ReportingDate",
            sortType: "basic",
            width:116,
        },
       
    ];
    //
    useEffect(() => {
        getAptevoInventory();
    }, [])
    async function getAptevoInventory() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=InventoryMonthly&TaskTypeCode=AptevoInventory`;
        await _HttpServices
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=1489=${outbounddata.File_Process_ID}`)AptevoInventory
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=${outbounddata.File_Process_ID}`)
            .getData(url)

            .then((data) => {
                const serviceFeeResult = data.data;
                if (serviceFeeResult.length > 0) {
                    serviceFeeResult.map((res) => {
                        res.ExpirationDate = moment(res.ExpirationDate).format('MM/DD/YYYY');
                        res.ReportingDate = moment(res.ReportingDate).format('MM/DD/YYYY');                          
                        res.UnitsOrVial = res.UnitsOrVial == null? "0.0000":  (res.UnitsOrVial*1).toFixed(4);
                        res.TotalUnit = res.TotalUnit == null? "0.0000":  (res.TotalUnit*1).toFixed(4);
                    })
                }
                setInventory(serviceFeeResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });

    }
    async function headerData(salesSource) {
        var data_to_download = []
        if(salesSource.length != 0){
        salesSource.map((data, pidex) => {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = salesSource[pidex][excelColumns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })}
        else {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = ""
            })
            data_to_download.push(record_to_download)
        }
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Sales Source Data");
    }
    const EditRecords = () =>{
        localStorage.setItem("AptevoInventory",JSON.stringify(inventory));
        history.push("/AptevoInventoryEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Aptevo Inventory Source</h2>
                {loading ? <Loader /> : null}
                <div>
                {inventory.length > 0 && userData.RoleID === 1 && (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}

                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,inventory,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
             {/* Toaster */}
             {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Aptevo Inventory Source.</p> :
                                <Fragment>
                                    {inventory.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={inventory} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default AptevoInventorySourcePage;